(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.dashboard', indexController);

    indexController.$inject = ["modules.goals.service", "bizUser", "mobiEvent", "$rootScope", "$filter"];

    function indexController(engagementGoalsService, bizUser, event, $rootScope, $filter) {
        var vm = this;
        vm.Tasks = [];

        vm.labels = ["Framsteg", "Kvar"];
        vm.colors = ["#0079EA", "#65AEF2"];
        vm.options = { cutoutPercentage: 75 };
        vm.data = [0, 100];
        vm.UserProgressSum = {};
        vm.UserProgressSum.ProgressValue = 0;

        vm.events = [];

        vm.LoggedInUserId = bizUser.getLoggedInUser().Id;        

        vm.Init = Init;

        vm.GetProgressSum = GetProgressSum;
        vm.GetTasks = GetTasks;
        vm.GoToNextPeriod = GoToNextPeriod;
        vm.GoToPreviousPeriod = GoToPreviousPeriod;
        vm.IsSelectedPeriodInCurrentYear = IsSelectedPeriodInCurrentYear;
        vm.GetGoals = GetGoals;

        function GoToNextPeriod() {
            engagementGoalsService.IncreaseSelectedPeriod();
            $rootScope.$broadcast('GOAL_NEW_DATE_SELECTED');
            vm.Init();
        }

        function GoToPreviousPeriod() {
            engagementGoalsService.DecreaseSelectedPeriod();
            $rootScope.$broadcast('GOAL_NEW_DATE_SELECTED');
            vm.Init();
        }

        function IsSelectedPeriodInCurrentYear() {
            var selected = engagementGoalsService.GetSelectedPeriod().StartDate;
            return BizPartCoreHelpers.getDateNow().year() == moment(selected).year();
        }
        

        function GetProgressSum() {
            
            engagementGoalsService.GetProgressSum(true).then(GetProgressSumCallback);

            function GetProgressSumCallback(response) {
                vm.ProgressSum = BizPartCoreHelpers.getResponseValue(response);
                console.log(vm.ProgressSum);

                if (vm.ProgressSum.length > 0) {
                    vm.UserProgressSum = vm.ProgressSum.GetItemByValue('UserId', vm.LoggedInUserId);
                    var progressValue = vm.UserProgressSum.ProgressValue;                    
                    if (progressValue > 100) {
                        progressValue = 100;
                    }
                    vm.data = [Math.round(progressValue), Math.round(100 - progressValue)];
                }                   
            }            
        }

        function GetTasks() {
            engagementGoalsService.GetTasks(true, moment().subtract(3, 'months'), moment().add(3, 'months')).then(GetTasksCallback);

            function GetTasksCallback(response) {
                vm.Tasks = BizPartCoreHelpers.getResponseValue(response, []);

                vm.events = [];
                for(var i = 0; i < vm.Tasks.length; i++) {
                    var task = vm.Tasks[i];
                    var color = "#65AEF2";
                    
                    if(task.IsCompleted) {
                        color = "#3dd452";
                    }

                    vm.events.push(new event(task.Id, "TASK", task.Text, task.DateLocal, null, color));
                }
            }
        }

        function GetGoals() {
            engagementGoalsService.GetGoals().then(GetGoalsCallback);

            function GetGoalsCallback(response) {
                var goals = BizPartCoreHelpers.getResponseValue(response, []);                
                vm.NegativeGoals = $filter('filter')(goals, { IsNegative: true });
            }
        }

        function Init() {
            vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();
            vm.GetProgressSum();
            vm.GetTasks();
            vm.GetGoals();
        }
        
        vm.$onInit = function () {
            vm.Init();
        }

        $rootScope.$on('GOALPROGRESSUPDATED', function (event) {            
            vm.GetProgressSum();
        });
    }

})(window.angular);
